module.exports = "https://bin.bnbstatic.com/_next/static/images/DOCK_landing_page-CN-e2edf209b0ef42fe016f20d7489224e4.jpg";